

/**
 * 
 * @param {string} str - str contains ${$.SOMETHING} will be replace 
 * @param {Object} replace - object contains keys appeared in message {"${$.SOMETHING}": "str to to be replaced"}
 * @returns new replaced string 
 * 
 * @example
 * 
 * const str = "hello ${$.A}, user ${$.B}!"
 *
 * // hello world, user foo!
 * replacePlaceholder(str, {
 *  "${$.A}": "world",
 *  "${$.B}": "foo",
 * })
 * 
 */
const replacePlaceholder = (str, replace) =>
  str.replace(/\${\$.\w+}/g, (match) => replace[match])

const LanguagesUtils = {
  replacePlaceholder,
}

export default LanguagesUtils